import React, { useState, useEffect } from 'react';

function Timer({setTimeover,time=300}) {
  const [seconds, setSeconds] = useState(time);
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    let intervalId;

    if (isActive) {
      intervalId = setInterval(() => {
        setSeconds(prevSeconds => prevSeconds - 1);
      }, 1000);
    } else if (!isActive && seconds !== 0) {
      clearInterval(intervalId);
    }
    
    if(seconds < 1){
        setTimeover(true);
        clearInterval(intervalId)
    }

    return () => clearInterval(intervalId);
  }, [isActive, seconds]);

  const toggleTimer = () => {
    setIsActive(isActive);
  };

  useEffect(() =>{
    toggleTimer();
  },[]);

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return (
    <div className='timer'>
      <div className='text-center'>
        {`${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`}
      </div>
    </div>
  );
}

export default Timer;